import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import axiosInstance from "../../services/auth";
import { useCombinedContext } from "../../context/CombinedContext";

const Hours = ({ vessel, onClose, fetchVessel, userRole }) => {
  const { formatPrice } = useCombinedContext();

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);

  const [month, setMonth] = useState("");
  const [year, setYear] = useState(currentYear.toString());
  const [pipingTrade, setPipingTrade] = useState("");
  const [pipingManualHrs, setPipingManualHrs] = useState("");
  const [pipingIsrpHrs, setPipingIsrpHrs] = useState("");
  const [pipingTotal, setPipingTotal] = useState("");
  const [mechTrade, setMechTrade] = useState("");
  const [mechManualHrs, setMechManualHrs] = useState("");
  const [mechIsrpHrs, setMechIsrpHrs] = useState("");
  const [mechTotal, setMechTotal] = useState("");
  const [remark, setRemark] = useState("");
  const [editingHoursId, setEditingHoursId] = useState(null);
  const [hoursData, setHoursData] = useState(vessel?.hours || []);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [hoursToDelete, setHoursToDelete] = useState(null);

  // useEffect(() => {
  //   setHoursData(vessel?.hours || []);
  // }, [vessel]);

  useEffect(() => {
    const total =
      parseFloat(pipingManualHrs || 0) + parseFloat(pipingIsrpHrs || 0);
    setPipingTotal(total.toFixed(2));
  }, [pipingManualHrs, pipingIsrpHrs]);

  useEffect(() => {
    const total = parseFloat(mechManualHrs || 0) + parseFloat(mechIsrpHrs || 0);
    setMechTotal(total.toFixed(2));
  }, [mechManualHrs, mechIsrpHrs]);

  const totalHoursSum = hoursData
    .reduce((acc, item) => {
      return acc + parseFloat(item.total_hrs || 0);
    }, 0)
    .toFixed(2);

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal")) onClose();
  };

  const openDeleteModal = (hoursId) => {
    setHoursToDelete(hoursId);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setHoursToDelete(null);
  };

  const confirmDelete = async () => {
    try {
      await axiosInstance.delete(
        `/vessel/vessels/hours/${vessel._id}/${hoursToDelete}`
      );
      toast.success("Hours entry deleted!");
      setHoursData((prev) => prev.filter((item) => item._id !== hoursToDelete));
      if (editingHoursId === hoursToDelete) resetForm();
    } catch (error) {
      // console.error("Delete error:", error);
      toast.error(error.response?.data?.message || "Error deleting hours");
    }
    closeDeleteModal();
  };

  const handleSubmitHours = async () => {
    if (!month || !year) return toast.error("Please select month and year.");

    const pipingTotalFloat =
      parseFloat(pipingManualHrs || 0) + parseFloat(pipingIsrpHrs || 0);
    const mechTotalFloat =
      parseFloat(mechManualHrs || 0) + parseFloat(mechIsrpHrs || 0);
    const total_hrs = pipingTotalFloat + mechTotalFloat;

    const payload = {
      month,
      year,
      total_hrs: parseFloat(total_hrs),
      piping_dept: {
        trade: pipingTrade,
        manual_entry_hrs: pipingManualHrs,
        isrp_main_hrs: pipingIsrpHrs,
        total_hrs_pf: pipingTotalFloat,
      },
      mechanical_dept: {
        trade: mechTrade,
        manual_entry_hrs: mechManualHrs,
        isrp_main_hrs: mechIsrpHrs,
        total_hrs_me: mechTotalFloat,
      },
      remark,
    };

    try {
      if (editingHoursId) {
        await axiosInstance.patch(
          `/vessel/vessels/hours/${vessel._id}/${editingHoursId}`,
          payload
        );
        toast.success("Hours updated!");
        setHoursData((prev) =>
          prev.map((item) =>
            item._id === editingHoursId ? { ...item, ...payload } : item
          )
        );
      } else {
        const { data } = await axiosInstance.post(
          `/vessel/vessels/hours/${vessel._id}`,
          payload
        );
        toast.success("Hours added!");
        const newEntry = { ...payload, _id: data._id };
        setHoursData((prev) => [...prev, newEntry]);
      }
      resetForm();
      fetchVessel && fetchVessel();
    } catch (error) {
      // console.error("Submit error:", error);
      toast.error(error.response?.data?.message || "Error submitting hours");
    }
  };

  const handleEditPrefill = (item) => {
    setMonth(item.month);
    setYear(item.year);
    setPipingTrade(item.piping_dept?.trade || "");
    setPipingManualHrs(item.piping_dept?.manual_entry_hrs || "");
    setPipingIsrpHrs(item.piping_dept?.isrp_main_hrs || "");
    setPipingTotal(item.piping_dept?.total_hrs_pf || "");
    setMechTrade(item.mechanical_dept?.trade || "");
    setMechManualHrs(item.mechanical_dept?.manual_entry_hrs || "");
    setMechIsrpHrs(item.mechanical_dept?.isrp_main_hrs || "");
    setMechTotal(item.mechanical_dept?.total_hrs_me || "");
    setRemark(item.remark || "");
    setEditingHoursId(item._id);
  };

  const resetForm = () => {
    setMonth("");
    setYear(currentYear.toString());
    setPipingTrade("");
    setPipingManualHrs("");
    setPipingIsrpHrs("");
    setPipingTotal("");
    setMechTrade("");
    setMechManualHrs("");
    setMechIsrpHrs("");
    setMechTotal("");
    setRemark("");
    setEditingHoursId(null);
  };
  useEffect(() => {
    if (vessel?.hours && Array.isArray(vessel.hours)) {
      setHoursData(vessel.hours);
    } else {
      setHoursData([]);
    }
  }, [vessel]);

  return (
    <div>
      <div
        className="modal show d-block"
        tabIndex="-1"
        onClick={handleOutsideClick}
        style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
      >
        <ToastContainer />
        <div className="modal-dialog modal-xl modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header text-white text-center vesel_form">
              <h5 className="modal-title">Manage Hours</h5>
              <button
                type="button"
                className="btn-close text-white"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body vesel_form">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Month</th>
                    <th>Year</th>
                    <th>Piping Trade</th>
                    <th>Piping Manual Hrs</th>
                    <th>Piping ISRP Hrs</th>
                    <th>Piping Total</th>
                    <th>Mech Trade</th>
                    <th>Mech Manual Hrs</th>
                    <th>Mech ISRP Hrs</th>
                    <th>Mech Total</th>
                    <th>Total Hrs</th>
                    <th>Remark</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {hoursData.length > 0 ? (
                    hoursData.map((item) => (
                      <tr key={item._id}>
                        <td>{item.month}</td>
                        <td>{item.year}</td>
                        <td>{item.piping_dept?.trade || "-"}</td>
                        <td>
                          {item.piping_dept?.manual_entry_hrs != null
                            ? Number(item.piping_dept.manual_entry_hrs).toFixed(
                                2
                              )
                            : "-"}
                        </td>
                        <td>
                          {item.piping_dept?.isrp_main_hrs != null
                            ? Number(item.piping_dept.isrp_main_hrs).toFixed(2)
                            : "-"}
                        </td>
                        <td>
                          {Number(item.piping_dept?.total_hrs_pf || 0).toFixed(
                            2
                          )}
                        </td>
                        <td>{item.mechanical_dept?.trade || "-"}</td>
                        <td>
                          {item.mechanical_dept?.manual_entry_hrs != null
                            ? Number(
                                item.mechanical_dept.manual_entry_hrs
                              ).toFixed(2)
                            : "-"}
                        </td>
                        <td>
                          {item.mechanical_dept?.isrp_main_hrs != null
                            ? Number(
                                item.mechanical_dept.isrp_main_hrs
                              ).toFixed(2)
                            : "-"}
                        </td>
                        <td>
                          {Number(
                            item.mechanical_dept?.total_hrs_me || 0
                          ).toFixed(2)}
                        </td>
                        <td>{Number(item.total_hrs).toFixed(2)}</td>
                        <td>{item.remark || "-"}</td>
                        <td>
                          <button
                            className="btn btn-outline-success btn-sm me-2"
                            onClick={() => {
                              // console.log("Button clicked with item:", item);
                              handleEditPrefill(item);
                            }}
                          >
                            <i className="bi bi-pencil-square"></i>
                          </button>
                          {["admin", "superadmin"].includes(userRole) && (
                            <button
                              className="btn btn-outline-danger btn-sm"
                              onClick={() => openDeleteModal(item._id)}
                            >
                              <i className="bi bi-trash3"></i>
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="13" className="text-center">
                        No hours entries found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className="mb-3 h6">
                <strong>Total Hours Sum:</strong> {totalHoursSum}
              </div>
              <div className="my-3">
                <h6>{editingHoursId ? "Update Hours" : "Add New Hours"}</h6>
                <div className="row g-2">
                  {/* Month & Year */}
                  <div className="col-md-2">
                    <select
                      className="form-select"
                      value={month}
                      onChange={(e) => setMonth(e.target.value)}
                    >
                      <option value="">Select Month</option>
                      {months.map((m) => (
                        <option key={m} value={m}>
                          {m}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-2">
                    <select
                      className="form-select"
                      value={year}
                      onChange={(e) => setYear(e.target.value)}
                    >
                      {years.map((yr) => (
                        <option key={yr} value={yr}>
                          {yr}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Piping */}
                  <div className="col-md-2">
                    <input
                      placeholder="Piping Trade"
                      className="form-control"
                      value={pipingTrade}
                      onChange={(e) => setPipingTrade(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2">
                    <input
                      placeholder="Piping Manual Hrs"
                      className="form-control"
                      value={pipingManualHrs}
                      onChange={(e) => setPipingManualHrs(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2">
                    <input
                      placeholder="Piping ISRP Hrs"
                      className="form-control"
                      value={pipingIsrpHrs}
                      onChange={(e) => setPipingIsrpHrs(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2">
                    <input
                      placeholder="Piping Total"
                      className="form-control"
                      value={pipingTotal}
                      onChange={(e) => setPipingTotal(e.target.value)}
                      disabled
                    />
                  </div>

                  {/* Mechanical */}
                  <div className="col-md-2">
                    <input
                      placeholder="Mech Trade"
                      className="form-control"
                      value={mechTrade}
                      onChange={(e) => setMechTrade(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2">
                    <input
                      placeholder="Mech Manual Hrs"
                      className="form-control"
                      value={mechManualHrs}
                      onChange={(e) => setMechManualHrs(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2">
                    <input
                      placeholder="Mech ISRP Hrs"
                      className="form-control"
                      value={mechIsrpHrs}
                      onChange={(e) => setMechIsrpHrs(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2">
                    <input
                      placeholder="Mech Total"
                      className="form-control"
                      value={mechTotal}
                      onChange={(e) => setMechTotal(e.target.value)}
                      disabled
                    />
                  </div>

                  <div className="col-md-12">
                    <textarea
                      placeholder="Remark"
                      className="form-control"
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                    />
                  </div>
                </div>

                <div className="mt-3">
                  <button className="button-3 me-2" onClick={handleSubmitHours}>
                    {editingHoursId ? "Update" : "Add"}
                  </button>
                  <button className="button-2" onClick={resetForm}>
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showDeleteModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-sm modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <p>Are you sure you want to delete this entry?</p>
                <button className="btn btn-danger me-2" onClick={confirmDelete}>
                  Yes
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={closeDeleteModal}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Hours;
